import { Stack, Typography } from '@mui/material';

import { errorMessages } from '../constants';

interface ErrorMessagesProps {
    errors: Error[];
}

const ErrorMessages = ({ errors }: ErrorMessagesProps) => (
    <Stack gap={1}>
        {errors.map((error, index) => (
            <Typography
                key={`${error.message}-${index}`}
                variant='body1'
                color='error.contrastText'
            >
                {errorMessages.general} {error.message}
            </Typography>
        ))}
    </Stack>
);

export default ErrorMessages;
